import { useFlags } from 'gatsby-plugin-launchdarkly';
import * as React from 'react';
import FooterWithNerdMenu from './FooterWithNerdMenu';
import OldFooter from './OldFooter';

interface FooterProps {
  theme: string;
  language: Languages;
  menu: NerdMenuDrupalEdges;
  utilityMenu: NerdMenuDrupalEdges;
}

const Footer: React.FC<FooterProps> = function ({ language, theme, menu, utilityMenu }) {
  const { enableNerdMenuFooter } = useFlags();

  return enableNerdMenuFooter ? (
    <FooterWithNerdMenu menu={menu} utilityMenu={utilityMenu} />
  ) : (
    <OldFooter language={language} theme={theme} />
  );
};

export default Footer;
